import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetSubjectDataError,
  GetSubjectDataVariables,
  fetchGetSubjectData,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getSubjectData;

export function useGetSubjectData(
  variables: GetSubjectDataVariables,
  opts?: UseQueryOptions<Response, GetSubjectDataError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetSubjectDataError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/subjectdata',
      operationId: 'getSubjectData',
      variables,
    }),
    async () => {
      const res = await fetchGetSubjectData({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
